export default __webpack_public_path__ + "static/media/appstore.aa052339.png";